import React from 'react'
import Projects from './Projects';

const Main = () => {
  return (
    <main className="Main">
      <Projects />
    </main>
  );
}

export default Main;
